module.exports = __webpack_public_path__ + "img/r4sf.19e3045f.png";